import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  padding: 0;
  width: 100%;
  height: 100%;
  max-width: 9.9375rem;
  // Item de um flex (ContainerDolarAndQuotation, em pages/nova-farm/styles.js) -
  // sem isso, o min-width implícito do flexbox ("auto") impede encolher abaixo
  // do conteúdo interno, estourando o max-width acima e vazando do card.
  min-width: 0;
  max-height: 15.6875rem;
  
  margin: 0;
  gap: 0.6rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  
  background: #fff;
  text-align: center;
  border-radius: 0.9375rem;
  background-color: #F8F8F9;

  p {
   text-align: center;
  }

  .rate-info {
    padding: 1rem;
    padding-bottom: 0;
    
    gap: 0.6rem;
    display: flex;
    flex-direction: column;

    span {
      margin-top: 0.25rem;
     
      font-size: 0.75rem;
    }

    .rate-details {
      gap: 0.625rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }

  .chart-wrapper {
    width: 100%;
    height: 100%;
    max-height: 5.063rem;
  }

  @media (max-width: 1310px) {
    max-width: 49%;
  }

  @media (max-width: 1080px) {
    max-width: 100%;
  }

  .custom-selector {
    display: flex;
    justify-content: center;
  }
  .custom-selector select {
    width: 100%;
    
    border: 0;
    cursor: pointer;
    color: #589BFF;
    font-weight: 700;
    font-size: 0.5625rem;
    text-overflow: ellipsis;
    text-transform: uppercase;
    letter-spacing: 0.0625rem;
    background-color: #F8F8F9;
    font-family: 'Lato', sans-serif;
  }

  .custom-selector option {
    color: ${theme.colors.gray.Cinza_2};
    font-size: 0.7rem;
  }
`;

export const ContainerContent = styled.div`
  width: 159px;
  height: 251px;

  gap: 8px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

    >img{
        width: 100%;
        height: auto;
        max-width: 80px;
    }
  `;